import { TToastScope, TToastType } from '@features/ToastManager/model/types';

import { emitToast } from './toastBus';

export function showToast(
    text: string,
    opts?: { scope?: TToastScope; delay?: number; type?: TToastType }
) {
    emitToast({
        id: Date.now(),
        text,
        scope: opts?.scope ?? 'global',
        delay: opts?.delay,
        type: opts?.type ?? 'success',
    });
}
